import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		listPolicyNoteEmailsView_body: {
			display: 'flex',
			width: '100%',
			flexDirection: 'column',
		},
		listPolicyNoteEmailsView_section: {
			height: '100%',
			background: theme.palette.grey[100],
			padding: theme.spacing(1.5),
			borderRadius: theme.shape.borderRadius,
			border: `1px solid ${theme.palette.grey[400]}`,
			margin: theme.spacing(1.5, 1),
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-around',
			'& > div:last-child': {
				paddingTop: theme.spacing(1),
			},
			'& > div:first-child': {
				borderBottom: `1px solid ${theme.palette.grey[400]}`,
				paddingBottom: theme.spacing(1),
			},
			'& > div:nth-child(n+2):nth-last-child(n+2)': {
				borderBottom: `1px solid ${theme.palette.grey[400]}`,
				padding: theme.spacing(1, 0),
			},
			'& > div:only-child': {

			}
		},
		listPolicyNoteEmailsView_noteSection: {
			height: '100%',
			background: theme.palette.grey[100],
			padding: theme.spacing(1.5),
			borderRadius: theme.shape.borderRadius,
			border: `1px solid ${theme.palette.grey[400]}`,
			margin: theme.spacing(1.5, 1),
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-around',
		},
		listPolicyNoteEmailsView_details: {
			display: 'flex',
			flexDirection: 'column',
			[theme.breakpoints.down(BreakpointWidth.X_LARGE)]: {
				flexWrap: 'wrap',
			},
		},
		listPolicyNoteEmailsView_sectionLabel: {
			marginTop: theme.spacing(1),
			marginLeft: theme.spacing(1),
			color: theme.palette.grey[700],
		},
		listPolicyNoteEmailsView_noteDetailsWrapper: {
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
		},
		listPolicyNoteEmailsView_noteDetails: {

		},
		listPolicyNoteEmailsView_correspondenceDetailsWrapper: {
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
		},
		listPolicyNoteEmailsView_correspondenceDetails: {

		},
		listPolicyNoteEmailsView_notesWrapper: {
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
		},
		listPolicyNoteEmailsView_note: {

		},
		listPolicyNoteEmailsView_row: {
			display: 'flex',
			justifyContent: 'space-between',
			marginRight: theme.spacing(1),
			marginLeft: theme.spacing(1),
		},
		listPolicyNoteEmailsView_rowField: {
			fontWeight: theme.typography.fontWeightBold as any,
			marginRight: theme.spacing(1),
		},
		listPolicyNoteEmailsView_rowValue: {
			float: 'right',
			wordBreak: 'break-all',
		},
		listPolicyNoteEmailsView_rowValueLink: {
			color: theme.palette.grey[500],
		},
		listPolicyNoteEmailsView_noteEmailBody: {
			maxHeight: theme.spacing(50),
			display: 'flex',
			flexFlow: 'wrap',
			wordBreak: 'break-all',
		}
	});
});

export default useStyles;
